import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * Bottom Navigation Bar for Mobile
 * Native app-like navigation with 4 main actions
 */
import React from 'react';
import { Inbox, Star, Search, Menu } from 'lucide-react';
export const BottomNav = ({ activeTab, onTabChange, unreadCount, onMenuClick }) => {
    const tabs = [
        {
            id: 'inbox',
            icon: Inbox,
            label: 'Inbox',
            badge: unreadCount > 0 ? unreadCount : undefined
        },
        {
            id: 'starred',
            icon: Star,
            label: 'Starred',
            badge: undefined
        },
        {
            id: 'search',
            icon: Search,
            label: 'Search',
            badge: undefined
        },
        {
            id: 'menu',
            icon: Menu,
            label: 'Menu',
            badge: undefined
        }
    ];
    const handleTabClick = (tabId) => {
        if (tabId === 'menu') {
            onMenuClick();
        }
        else {
            onTabChange(tabId);
        }
    };
    return (_jsx("nav", { className: "bottom-nav", children: tabs.map((tab) => {
            const Icon = tab.icon;
            const isActive = activeTab === tab.id;
            return (_jsxs("button", { onClick: () => handleTabClick(tab.id), className: `bottom-nav-item ${isActive ? 'active' : ''}`, "aria-label": tab.label, "aria-current": isActive ? 'page' : undefined, children: [_jsxs("div", { style: { position: 'relative' }, children: [_jsx(Icon, { className: "bottom-nav-icon" }), tab.badge && (_jsx("span", { className: "bottom-nav-badge", children: tab.badge > 99 ? '99+' : tab.badge }))] }), _jsx("span", { className: "bottom-nav-label", children: tab.label })] }, tab.id));
        }) }));
};
export default BottomNav;
